export default __webpack_public_path__ + "img/qr-image.a5170fb5.png";